import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import updateItem from '../../actions/updateItem'
import showMore from '../../actions/showMore'
import setActiveHotel from '../../actions/setActiveHotel'
import fetchAvailabilities from '../../actions/fetchAvailabilities'

import ReinsuranceBanner from '../ReinsuranceBanner'
import BecomeMemberBanner from '../BecomeMemberBanner'
import DecreasingBanner from '../DecreasingBanner'
import HotelCardLoader from 'js/components/searchResults/components/HotelCardLoader/HotelCardLoader';
import {LOADER_FETCH_SEARCH_RESULTS, LOADER_SEARCHBOX_SUBMIT} from 'js/components/Loader/constants';

class SearchList extends Component {
  static propTypes = {
    updateItemAction: PropTypes.func.isRequired,
    showMoreAction: PropTypes.func.isRequired,
    fetchAvailabilitiesAction: PropTypes.func.isRequired,
    setActiveHotelAction: PropTypes.func.isRequired,
    mediaType: PropTypes.string.isRequired,
    datesApply: PropTypes.bool.isRequired,
    results: PropTypes.arrayOf(Object),
    extendedReviews: PropTypes.objectOf(Object),
    setting: PropTypes.objectOf(Object),
    browser: PropTypes.objectOf(Object).isRequired,
    discountTooltipText: PropTypes.string,
    resultsLoading: PropTypes.bool.isRequired,
    reinsuranceBanner: ReinsuranceBanner.propTypes.data,
    becomeMemberBanner: BecomeMemberBanner.propTypes.data,
  }

  static defaultProps = {
    results: [],
    extendedReviews: {},
    setting: {},
    discountTooltipText: '',
  }


  constructor(props) {
    super(props)

    this.state = {
      countItemsToShow: 10,
      scrollPixelsY: 0,
      conditionsTop: 0,
      loading: false,
      hotelId: null,
      isSameHotel: false,
    }

    document.addEventListener('mapPointActive', (e) => {
      this.setState({
        hotelId: e?.detail?.hotelId,
        isSameHotel: e?.detail?.isSameHotel,
      })
    })
  }

  getAvailabilities = async () => {
    const { fetchAvailabilitiesAction } = this.props
    this.setState({
      loading: true,
    })

    await fetchAvailabilitiesAction()
    this.setState({
      loading: false
    })
  }

  componentDidMount() {
    this.getAvailabilities();

    window.addEventListener('scroll', this.checkPosition)
    window.addEventListener('scroll', this.handleScroll)

    const searchResultsTrigger = document.querySelector('.search-results--more-trigger')
    const coordsSearchResultsTrigger = this.getCoords(searchResultsTrigger)

    this.setState({
      conditionsTop: coordsSearchResultsTrigger.top,
    })
  }

  componentDidUpdate() {
    const { hotelId, countItemsToShow } = this.state
    if (!hotelId) {
      return
    }

    const hotelIndex = this.props.results.findIndex(item => item.id === hotelId)
    if (hotelIndex < 0 || hotelIndex < countItemsToShow) {
      return
    }

    this.setState({
      countItemsToShow: hotelIndex + 1,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    this.setState({
      scrollPixelsY: window.scrollY,
    })

    if (this.state.scrollPixelsY >= this.state.conditionsTop) {
      this.setState(state => ({
        countItemsToShow: state.countItemsToShow + 1,
      }))
    }

    if(this.state.isSameHotel) {
      this.setState({
        isSameHotel: false,
      })
    }
  }

  onClickHandler = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  showMore = (item) => {
    const { showMoreAction, updateItemAction, setActiveHotelAction } = this.props
    if (item.isMoreVisible) {
      updateItemAction(item.id, 'isMoreVisible', false)
    } else {
      showMoreAction(item)
      setActiveHotelAction(item)
    }
  }

  handleToggleHoverReview = (hotelId) => {
    const { setActiveHotelAction, results } = this.props
    setActiveHotelAction(results.find(res => res.id === hotelId))
  }

  checkPosition = () => {
    const backToTop = document.querySelector('.back-to-top')

    if (backToTop) {
      if (window.pageYOffset > 1500 && window.innerWidth <= 768) {
        backToTop.classList.add('visible')
      } else {
        backToTop.classList.remove('visible')
      }
    }
  }

 getCoords = (elem) => {
   const box = elem.getBoundingClientRect()

   return {
     top: box.top + window.pageYOffset,
     right: box.right + window.pageXOffset,
     bottom: box.bottom + window.pageYOffset,
     left: box.left + window.pageXOffset,
   };
 };

  render() {
    const {
      results,
      datesApply,
      setting,
      discountTooltipText,
      resultsLoading,
      cardsUpdateLoading,
      itemComponent,
      className,
      reinsuranceBanner,
      becomeMemberBanner,
      decreasingBanner,
    } = this.props
    const {
      loading,
    } = this.state
    const ListItemComponent = itemComponent;
    const renderHotelCard = (data, topCard) => data.map(item => (
      <ListItemComponent
        {...item}
        key={item.id}
        showMore={this.showMore}
        datesApply={!!datesApply}
        topCard={topCard}
        toggleHoverReview={this.handleToggleHoverReview}
        discountTooltipText={discountTooltipText}
        resultsLoading={cardsUpdateLoading || loading}
        isSameHotel={this.state.isSameHotel && this.state.hotelId === item.id}
      />
    ))

    return resultsLoading
      ? (<div className={className}><HotelCardLoader length={5} /></div>)
      : (
        <div>
          <div className={className}>
            {resultsLoading && (<HotelCardLoader length={5}/>)}
            {renderHotelCard(results.slice(0, 1), true)}
            {decreasingBanner && (<DecreasingBanner data={decreasingBanner}/>)}
            {renderHotelCard(results.slice(1, 3), true)}
            {reinsuranceBanner && (<ReinsuranceBanner data={reinsuranceBanner}/>)}
            {renderHotelCard(results.slice(3, 4))}
            {becomeMemberBanner && (<BecomeMemberBanner data={becomeMemberBanner}/>)}
            {renderHotelCard(results.slice(4, this.state.countItemsToShow))}
          </div>
          {results.length > 5 && (
            <button
              type="button"
              className="back-to-top"
              onClick={this.onClickHandler}
            >
              {setting.buttonText}
            </button>
          )}
          <div className="search-results--more-trigger"/>
        </div>
      )
  }
}

const mapStateToProps = ({
  main: {
    setting,
    results,
  },
  url,
  extendedReviews,
  bookingUrl,
  globalLoader: {
    isShow,
    activeLoaders,
  },
}) => ({
  setting,
  results,
  datesApply: !!url.parameters.dateIn,
  extendedReviews,
  discountTooltipText: setting.searchResults.discount_tooltip_text,
  bookingUrl,
  cardsUpdateLoading: isShow && activeLoaders.includes(LOADER_FETCH_SEARCH_RESULTS),
  resultsLoading: isShow && activeLoaders.includes(LOADER_SEARCHBOX_SUBMIT),
})

const mapDispatchToProps = {
  updateItemAction: updateItem,
  fetchAvailabilitiesAction: fetchAvailabilities,
  showMoreAction: showMore,
  setActiveHotelAction: setActiveHotel,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchList)
